import { LocalizationService } from '@abp/ng.core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cxTimePipe',
  standalone: true,
})
export class CXTimePipe implements PipeTransform {
  constructor(private localizationService: LocalizationService) {}

  transform(seconds: number | null | undefined, showShortcuts: boolean = false): string {
    if (seconds === null || seconds === undefined) {
      return '';
    }

    const mins = Math.floor(seconds / 60)
      .toString()
      .padStart(2, '0');
    const secs = Math.floor(seconds % 60)
      .toString()
      .padStart(2, '0');

    if (showShortcuts) {
      return this.localizationService.instant('::TimeShortcut', mins, secs);
    }

    return `${mins}:${secs}`;
  }
}
